import React, { useState } from "react";
import { Theme } from "../../theme/Theme";
import { Icon } from "@iconify/react";
import colors from "../../theme/colors";
import { useNavigate } from "react-router-dom";
import LegalContent from "./LegalContent";

export default function AuthLayout({
  children,
  title,
  subtitle,
  showTabs = false,
  tabSide = 0,
  switchTabRoutePrefix = "", // e.g. "/login", "/signup"
  showLegalLinks = true,
}) {
  const navigate = useNavigate();

  // Legal Modals State
  const [termsOpen, setTermsOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);

  const handleTabSwitch = (side) => {
    if (switchTabRoutePrefix === "/login") {
      navigate(side === 1 ? "/business/login" : "/login");
    } else if (switchTabRoutePrefix === "/signup") {
      navigate(side === 1 ? "/business/signup" : "/signup");
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand">
          <img src="/logo.jpeg" alt="Witter24" className="auth-brand-logo" />
          <p className="auth-brand-name">Witter24</p>
        </div>

        {showTabs && (
          <div className={`auth-type-tabs${tabSide === 1 ? " is-business" : ""}`}>
            <div className="auth-tab-indicator" />
            <button
              type="button"
              onClick={() => handleTabSwitch(0)}
              className={`auth-tab${tabSide === 0 ? " auth-tab--active" : ""}`}
            >
              <Icon icon="ph:user" width={18} />
              Normal 
            </button>
            <button
              type="button"
              onClick={() => handleTabSwitch(1)}
              className={`auth-tab${tabSide === 1 ? " auth-tab--active" : ""}`}
            >
              <Icon icon="ph:buildings" width={18} />
              Business
            </button>
          </div>
        )}

        {title && <div style={Theme.font24SemiBold} className="mb-3">{title}</div>}
        {subtitle && <div style={Theme.modalDescription} className={showTabs ? "" : "mb-3"}>{subtitle}</div>}

        {children}

        {showLegalLinks && (
          <>
            <div style={{ marginTop: 24, textAlign: "center" }}>
              <span onClick={() => setTermsOpen(true)} style={{ ...Theme.font14SemiBold, color: colors.mainTextColor, marginRight: 8, cursor: 'pointer' }}>
                Terms & Conditions
              </span>
              <span style={{ color: "var(--border-subtle)", margin: "0 8px" }}>|</span>
              <span onClick={() => setPrivacyOpen(true)} style={{ ...Theme.font14SemiBold, color: colors.mainTextColor, marginLeft: 8, cursor: 'pointer' }}>
                Privacy Policy
              </span>
            </div>

            <LegalContent
              type="terms"
              isModal
              isOpen={termsOpen}
              onClose={() => setTermsOpen(false)}
            />

            <LegalContent
              type="privacy"
              isModal
              isOpen={privacyOpen}
              onClose={() => setPrivacyOpen(false)}
            />
          </>
        )}
      </div>
    </div>
  );
}
